export default {
  noData: '新しいタスクはありません',
  headerTitle: 'タスクセンター',
  limitData: '過去14日間の最初の50のタスクのみを表示',
  jobStatus: {
    pending: '処理待ち',
    running: '生成中',
    success: '生成成功',
    failed: '生成失敗',
    partSuccess: '一部成功',
    stopped: '終了',
  },
  jobType: {
    vrecRecording: 'スクリーンショットのエクスポート',
    veRender: '動画エクスポート',
    VeSimple: '動画テンプレート',
    aigcTask: 'AIビデオ生成',
    aiBanner: 'AI画像生成',
    avatarVideo: 'アバターから動画',
    gmPush: '複数の組み合わせのプレイアブルのプッシュ',
    dmDown: 'カスタムプレイアブルダウンロード',
    dmPush: 'カスタムプレイアブルプッシュ',
    aiRemove: 'AI除去',
    subtitles: '字幕認識',
  },
  title: '複数の組み合わせのプレイアブルのダウンロード',
}
